import { createStore } from 'satcheljs';
import { map } from 'mobx';
// Import mutators so they are initialized at the same time as the store
import '../mutators/updateFolderCountsMutator';
var initialFolderTreeViewStateStore = {
    folderNodeViewStates: map({}),
    contextMenuState: null,
    folderTextFieldViewState: null,
    isDraggedOver: false,
    withContextMenuFolderId: null,
};
var store = createStore('folderViewState', initialFolderTreeViewStateStore)();
export default store;
//# sourceMappingURL=store.js.map